export default __webpack_public_path__ + "static/media/ic_login.e64130c8.svg";